import cn from 'classnames'

import css from './filter-button.module.scss'

export type FilterButtonProps = {
  label: string
  selected?: number
  icon?: React.ReactNode
  isOpen?: boolean
  onClick?: () => void
  className?: string
}

const FilterButton = ({ label, icon, selected = 0, isOpen = false, onClick, className }: FilterButtonProps) => {
  return (
    <div
      className={cn([css.container, selected > 0 && !isOpen ? css.selected : '', className])}
      onClick={onClick}
      role="button"
    >
      {icon}
      <span>{label}</span>
    </div>
  )
}
export default FilterButton
